export const MAX_TODO_HISTORY = 10;
export const POMODORO_WORK_TIME = 25;
export const POMODORO_BREAK_TIME = 5;
export const SECONDS_PER_MINUTE = 60;
export const MILLISECONDS_PER_SECOND = 1000;
export const URL_PREFIX = "http://";
export const URL_TRUNCATE_LENGTH = 40;
